import { FlowFormData, FlowSubmissionData } from '../types/addFlow.types';
import { FLOW_TRIGGER } from '../constants/flowTriggers';
import { formatTimeForAPI } from '@/lib/helpers';

/**
 * Build flow submission data from form data
 */
export const buildFlowSubmissionData = (formData: FlowFormData): FlowSubmissionData => {
    const isPurchaseTrigger = formData.selectedTrigger === FLOW_TRIGGER.CHECKOUT;
    const isCartAbandonmentTrigger = formData.selectedTrigger === FLOW_TRIGGER.CART_ABANDONMENT;
    const isTimeTrigger = formData.selectedTrigger === FLOW_TRIGGER.TIME;

    const flowData: FlowSubmissionData = {
        status: 'published',
        type: 'event-triggered',
        trigger: formData.selectedTrigger,
        data: {
            name: formData.flowName || 'New Email Flow',
        },
    };

    // Add product filters for purchase/cart-abandonment triggers
    if (isPurchaseTrigger || isCartAbandonmentTrigger) {
        const filters: any = {
            page_id_list: formData.selectedProducts || [0],
        };

        if (formData.selectedExcludeProducts && formData.selectedExcludeProducts.length > 0) {
            filters.exclude_page_id_list = formData.selectedExcludeProducts;
        }

        if (isCartAbandonmentTrigger) {
            filters.exclude_page_id_list = formData.selectedProducts || [0];
        }

        flowData.data.filters = filters;
    }

    // Add date/time for time-based triggers
    if (isTimeTrigger) {
        flowData.data.specific_time = {
            tags: formData.tags || [],
            date: formData.selectedDate || '',
            time: formatTimeForAPI(formData.selectedTime || 0),
            timezone: formData.selectedTimezone || '',
        };
    }

    return flowData;
};

/**
 * Validate product selection - check for duplicates between trigger and removal
 */
export const validateProductSelection = (
    selectedProducts: number[] | undefined,
    excludeProducts: number[] | undefined
): { isValid: boolean; duplicates: number[] } => {
    if (!selectedProducts || !excludeProducts || selectedProducts.length === 0 || excludeProducts.length === 0) {
        return { isValid: true, duplicates: [] };
    }

    const duplicates = selectedProducts.filter(id => excludeProducts.includes(id));

    return {
        isValid: duplicates.length === 0,
        duplicates,
    };
};
